import { useMemo } from 'react';
import { CommunityGroup, RoleEnum } from '@juno/client-api/model';
import { useSettings } from '../routing/RoutingMediator';

interface GroupMembershipProps {
  thisGroup: CommunityGroup | undefined;
}
interface GroupMembershipReturn {
  iAmMember: boolean;
  iAmImpliedMember: boolean; // for HL Group hierarchy
  iAmPendingMember: boolean;
  iAmAdmin: boolean;
}
export const useGroupMembership: (props: GroupMembershipProps) => GroupMembershipReturn = ({
  thisGroup,
}) => {
  const { user, impliedAdminOfGroups, impliedMemberOfGroups } = useSettings();

  const iAmMember = useMemo(() => {
    return !!user?.community_groups_member?.find((group) => group === thisGroup?.id);
  }, [user, thisGroup?.id]);

  const iAmImpliedMember = useMemo(() => {
    return !!impliedMemberOfGroups?.find((g) => thisGroup?.id === g);
  }, [impliedMemberOfGroups, thisGroup?.id]);

  const iAmPendingMember = useMemo(() => {
    return !!user?.community_groups_pending_member?.find((group) => group === thisGroup?.id);
  }, [user, thisGroup?.id]);

  const iAmAdmin = useMemo(() => {
    if (user?.role === RoleEnum.NUMBER_1 || user?.role === RoleEnum.NUMBER_2) return true;
    if (thisGroup?.admins?.find((admin) => admin.id === user?.id)) return true;
    if (impliedAdminOfGroups?.find((g) => thisGroup?.id === g)) return true;
    return false;
  }, [thisGroup?.admins, user, impliedAdminOfGroups]);

  return { iAmMember, iAmImpliedMember, iAmPendingMember, iAmAdmin };
};
